import { render, staticRenderFns } from "./request.vue?vue&type=template&id=dbf8fd16&"
import script from "./request.vue?vue&type=script&lang=ts&"
export * from "./request.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports